<template>
  <svg
    @click="check"
    class="detect"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
  >
    <g
      v-for="(v, i) in boxes"
      :key="i">
      <rect
        v-show="editingBox.id !== v.id || !editingBox"
        class="detect__frame"
        :x="v.x1"
        :y="v.y1"
        :width="Math.round(Math.abs(v.x2 - v.x1))"
        :height="Math.round(Math.abs(v.y2 - v.y1))"
        :style="`
          stroke: ${selectedBoxId === v.id ? '#FFF' : v.color || ''};
          stroke-width: ${selectedBoxId === v.id ? 4 : 2};
          fill-opacity: ${selectedBoxId === v.id ? 0.25 : 0.4}
        `"
      />
    </g>
  </svg>

</template>

<script>
export default {
  name: "BoundingBox",
  props: {
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    boxes: {
      default: [],
    },
    selectedBoxId: {
      type: Number
    },
    editingBox: {
      default: false
    },
  },
  methods: {
    check(){
      console.log('checked');
    }
  },
}
</script>

<style lang="scss" scoped>
  .detect__frame {
    fill: #fff;
    stroke-opacity: 1;
    transition: all .2s linear;
  }

  .detect__text {
    font-size: 15px;
    font-weight: 600;
  }

  .detect {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
</style>
